export const promotionKeys = {
  list: "/public/promotions",
  userList: "/user/promotions",
  accept: "/user/promotions",
  cancel: "/user/promotions",
  change: "/user/promotions",
};
